import { render } from "./RafflesPage.vue?vue&type=template&id=35cd054f"
import script from "./RafflesPage.vue?vue&type=script&lang=js"
export * from "./RafflesPage.vue?vue&type=script&lang=js"

import "./RafflesPage.vue?vue&type=style&index=0&id=35cd054f&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__